import { render, staticRenderFns } from "./Weights.vue?vue&type=template&id=6ed678d0&scoped=true"
import script from "./Weights.vue?vue&type=script&lang=js"
export * from "./Weights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed678d0",
  null
  
)

export default component.exports